import * as types from './types';
import * as commonTypes from '../common/types';

export default (state = {}, action) => {
    switch (action.type) {
        case commonTypes.ASYNC_START: {
            return {
                ...state,
                loading: true,
                waitting: action.waitting,
                action: commonTypes.ASYNC_START,
            }
        }

        case commonTypes.ASYNC_END: {
            return {
                ...state,
                action: commonTypes.ASYNC_END,
                waitting: commonTypes.ASYNC_END,
                loading: false,
            }
        }
        case types.LIST_ORDER: {
            return {
                ...state,
                action: types.LIST_ORDER,
                orders: action.status ? action.payload.orders : [],
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                status: action.status,
                message: action.message,
            }
        }
        case types.DELETE_ORDERS: {
            return {
                ...state,
                action: types.DELETE_ORDERS,
                status: action.status,
                message: action.message,
            }
        }
        case types.DELETE_ORDER: {
            return {
                ...state,
                action: types.DELETE_ORDER,
                status: action.status,
                message: action.message,
            }
        }
        case types.CREATE_ORDER: {
            return {
                ...state,
                action: types.CREATE_ORDER,
                status: action.status,
                message: action.message,
            }
        }
        case types.UPDATE_ORDER: {
            return {
                ...state,
                action: types.UPDATE_ORDER,
                status: action.status,
                message: action.message,
            }
        }
        case types.DETAIL_ORDER: {
            return {
                ...state,
                action: types.DETAIL_ORDER,
                details: action.status ? action.payload.details : [],
                user: action.status ? action.payload.user : {},
                affilate: action.status ? action.payload.affilate : {},
                status: action.status,
                message: action.message,
            }
        }
        case types.MY_ORDER: {
            return {
                ...state,
                action: types.MY_ORDER,
                orders: action.status ? action.payload.orders : [],
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                status: action.status,
                message: action.message,
            }
        }

        case types.CANCEL_ORDER: {
            return {
                ...state,
                action: types.CANCEL_ORDER,
                status: action.status,
                message: action.message,
            }
        }

        case types.PAID_ORDER: {
            return {
                ...state,
                action: types.PAID_ORDER,
                status: action.status,
                message: action.message,
            }
        }

        case types.RE_CREATE_COMMISSION: {
            return {
                ...state,
                action: types.RE_CREATE_COMMISSION,
                status: action.status,
                message: action.message,
            }
        }


        default:
            return state;
    }
}

